import { useQueryParam } from '@atlassian/jira-router';

import { useSelectedConfigTab, useIsUserLocatedBoard } from '../../controllers';

export const LastOpenedConfigTab = ({ configParam }: { configParam: string }) => {
	const [, setConfigParam] = useQueryParam('config');
	const { getSelectedConfigTab, setSelectedConfigTab } = useSelectedConfigTab();
	const isUserLocatedBoard = useIsUserLocatedBoard();

	// Pages that should only be shown for project-located boards, need to redirect for user-located boards
	const projectOnlyTabs = ['timelineConfig', 'insightsConfig'];
	const defaultTab = 'filter';
	const selectedTab = getSelectedConfigTab();
	const lastOpenedTab = selectedTab ? JSON.parse(selectedTab) : defaultTab;

	if (
		isUserLocatedBoard &&
		projectOnlyTabs.includes(configParam) &&
		projectOnlyTabs.includes(lastOpenedTab)
	) {
		setConfigParam(defaultTab);
		setSelectedConfigTab(defaultTab);
	} else {
		setConfigParam(lastOpenedTab);
	}

	return null;
};
